import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';
import PredesComplianceMissingRequiredElementsReport
  from '../../components/PredesComplianceMissingRequiredElementsReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PredesComplianceMissingRequiredElementsSummarySelectors';

export function PredesComplianceMissingRequiredElementsSummaryContainer(props) {
  return (
    <PredesComplianceMissingRequiredElementsReport
      reportId={ReportDefinitions.PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PredesComplianceMissingRequiredElementsSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PredesComplianceMissingRequiredElementsSummaryContainer);
